import { Modelo } from '@ext/index';
import * as Types from './Publicacion.types';
import moment, { Moment } from 'moment';
import { IVariaciones } from './Variaciones/Variaciones.lib';
import { Variaciones } from '@/__env/lib/MercadoLibre/Publicaciones/Variaciones';
import { isObject } from 'util';
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';

export class IPublicacion extends Modelo
{

    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: string = '';
    public Cuenta: string = '';
    public Sku: string = '';
    public Codigo: string = '';
    public Titulo: string = '';
    public Categoria: string = '';
    public Precio: number = 0;
    public Stock: number = 0;
    public Ventas: number = 0;
    public Tipo: Types.Tipos;
    public Estado: Types.Estados;
    public Imagen: string = '';
    public Link: string = '';
    public Video: string = '';
    public Descripcion: string = '';
    public Garantia: string = '';
    public ModoEnvio: Types.TiposEnvio;
    public EnvioGratis: boolean = false;
    public RetiraCliente: boolean = false;
    public RetiraSucursal: boolean = false;
    public Salud: number = 0;
    public FechaPublicada: Moment = moment( '' );
    public FechaEditada: Moment = moment( '' );
    public Imagenes: Types.Imagen[] = [];

    public Variaciones: IVariaciones[] = [];
    public Atributos: Types.Atributo[] = [];
    public CostoDeEnvio: {
        Tipo: string;
        Costo: number;
    } = {
            Tipo: 'ninguno',
            Costo: 0,
        };

    public getJson (): any
    {
        let json: any = {};

        json.id = this.Id;
        json.cuenta = this.Cuenta;
        json.sku = this.Sku;
        json.codigo = this.Codigo;
        json.titulo = this.Titulo;
        json.categoria = this.Categoria;
        json.precio = this.Precio;
        json.stock = this.Stock;
        json.ventas = this.Ventas;
        json.tipo = this.Tipo.Id;
        json.estado = this.Estado.Id;
        json.imagen = this.Imagen;
        json.link = this.Link;
        json.video = this.Video;
        json.garantia = this.Garantia;
        json.modo_envio = this.ModoEnvio.Id;
        json.envio_gratis = this.EnvioGratis;
        json.retira_cliente = this.RetiraCliente;
        json.retira_sucursal = this.RetiraSucursal;
        json.salud = this.Salud;
        json.fecha_publicada = this.FechaPublicada.toSQL();
        json.fecha_editada = this.FechaEditada.toSQL();


        return json;
    }


    public set (): boolean
    {

        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Cuenta = !this.Json.cuenta ? '' : this.Json.cuenta;
        this.Sku = !this.Json.sku ? '' : this.Json.sku;
        this.Codigo = !this.Json.codigo ? '' : this.Json.codigo;
        this.Titulo = !this.Json.titulo ? '' : this.Json.titulo;
        this.Categoria = !this.Json.categoria ? '' : this.Json.categoria;
        this.Precio = !this.Json.precio ? 0 : this.Json.precio;
        this.Stock = !this.Json.stock ? 0 : this.Json.stock;
        this.Ventas = !this.Json.ventas ? 0 : this.Json.ventas;
        this.Tipo = Types.Tipos.toTipo( this.Json.tipo );
        this.Estado = Types.Estados.toTipo( this.Json.estado );
        this.Imagen = !this.Json.imagen ? '' : this.Json.imagen;
        this.Link = !this.Json.link ? '' : this.Json.link;
        this.Video = !this.Json.video ? '' : 'https://www.youtube.com/embed/' + this.Json.video;
        this.Garantia = !this.Json.garantia ? '' : this.Json.garantia;
        this.ModoEnvio = Types.TiposEnvio.toTipo( this.Json.modo_envio );
        this.EnvioGratis = this.Json.envio_gratis == 'S' || this.Json.envio_gratis == '1';
        this.RetiraCliente = this.Json.retira_cliente == 'S' || this.Json.retira_cliente == '1';
        this.RetiraSucursal = this.Json.retira_sucursal == 'S' || this.Json.retira_sucursal == '1';
        this.Salud = !this.Json.salud ? 0 : this.Json.salud;
        this.FechaPublicada = !this.Json.fecha_publicada ? moment( '' ) : moment( this.Json.fecha_publicada );
        this.FechaEditada = !this.Json.fecha_editada ? moment( '' ) : moment( this.Json.fecha_editada );
        if ( !this.FechaEditada )
            this.FechaEditada = this.FechaPublicada;

        if ( Array.isArray( this.Json.atributos ) )
        {
            this.Atributos = this.Json.atributos.map( ( x: any ) => new Types.Atributo( x ) );
        }

        if ( Array.isArray( this.Json.imagenes ) )
        {
            this.Imagenes = this.Json.imagenes.map( ( x: any ) => new Types.Imagen( x ) );
        }


        if ( Array.isArray( this.Json.variaciones ) )
        {
            this.Variaciones = this.Json.variaciones.map( ( x: any ) => new Variaciones( x ) );
        }


        if ( this.Json.costo_envio )
        {
            this.CostoDeEnvio.Costo = this.Json.costo_envio.costo;
            this.CostoDeEnvio.Tipo = this.Json.costo_envio.tipo;
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista (): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor ( Model: IPublicacion )
    {
        this.Model = Model;
    }

    public Model: IPublicacion;
}


export class OpcionDeEnvioMercadoEnvios extends Modelo
{

    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Costo: {
        Importe: number;
        Base: number;
        Lista: number;
        Descuento: number;
    } = {
            Base: 0,
            Importe: 0,
            Lista: 0,
            Descuento: 0,
        };

    public Destino: {
        Localidad: string;
        Provincia: string;
    };
    public Recomendada: boolean = false;
    public Nombre: string = '';

    public get Entrega ()
    {
        if ( this.Demora.Desde && this.Demora.Hasta && this.Demora.Desde.isValid() && this.Demora.Hasta.isValid() )
        {
            return `Llega dentro de ${ this.Demora.Desde.diff( moment(), 'days' ) } a ${ this.Demora.Hasta.diff( moment(), 'days' ) } días`;
        }
        if ( this.Demora.Desde && this.Demora.Desde.isValid() )
        {

            if ( this.Demora.Desde.diff( moment(), 'days' ) == 0 )
                return `Llega entre hoy y mañana`;
            else
                return `Llega dentro de ${ this.Demora.Desde.diff( moment(), 'days' ) } días`;
        }
    }

    public Demora: {
        Desde: Moment;
        Hasta: Moment;
    } = {
            Desde: null,
            Hasta: null,
        };

    public set (): boolean
    {

        this.Id = !this.Json.shipping_method_id ? 0 : this.Json.shipping_method_id;
        this.Nombre = !this.Json.name ? '' : this.Json.name;
        this.Costo.Base = !this.Json.base_cost ? 0 : this.Json.base_cost;
        this.Costo.Importe = !this.Json.cost ? 0 : this.Json.cost;
        this.Costo.Lista = !this.Json.list_cost ? 0 : this.Json.list_cost;
        this.Recomendada = this.Json.display == "recommended";
        if ( isObject( this.Json.discount ) )
        {
            if ( this.Json.rate > 0 )
            {
                this.Costo.Descuento = !this.Json.discount.rate ? 0 : this.Json.discount.rate;
            }
        }

        if ( isObject( this.Json.estimated_delivery_time ) && this.Json.estimated_delivery_time.date )
        {
            if ( moment( this.Json.estimated_delivery_time.date ).isValid() )
            {
                this.Demora.Desde = !this.Json.estimated_delivery_time.date ? moment( '' ) : moment( this.Json.estimated_delivery_time.date );
            }

            if ( moment( this.Json.estimated_delivery_time.offset.date ).isValid() )
            {
                this.Demora.Hasta = !this.Json.estimated_delivery_time.offset.date ? moment( '' ) : moment( this.Json.estimated_delivery_time.offset.date );
            }
        }

        this.Existe = true;
        return this.Existe;
    }

    public static Formatear ( opciones: OpcionDeEnvioMercadoEnvios[], pregunta: Pregunta ): string
    {
        let e = `El costo de envío a tu localidad `;
        for ( let op of opciones )
        {
            e += ' ' + op.Formatear( pregunta ) + ';';
        }
        return e;
    }

    public Formatear ( pregunta: Pregunta ): string
    {
        return `por envío ${ this.Nombre.toCapitalCase() } es de ${ this.Costo.Importe.toPesos() }`
            + ( this.Entrega ? ` y te ${ this.Entrega.toLowerCase() }` : '' )
            + ( this.Costo.Descuento > 1 ? `. ¡Te ofrecemos un ${ ( this.Costo.Descuento * 100 ).toPorcentaje( 0 ) } de descuento en este envío!` : '' )
            ;
    }

}